import React from 'react';
import pkg from '../../../package.json';

const REPO = 'https://tangled.org/psingletary.com/sifter';

const Footer = () => (
  <footer className="footer">
    <span>&copy; {new Date().getFullYear()} Sifter</span>
    <span className="footer-version">
      v{pkg.version} · <a href={REPO} target="_blank" rel="noopener noreferrer">source</a>
    </span>
  </footer>
);

export default Footer;